import CasesMobileTable from "./CasesMobileTable";

export default CasesMobileTable;
